module.exports = __webpack_public_path__ + "static/media/home-read-icon.b52fb6df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-read-icon.svg
// module id = 1902
// module chunks = 0